if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // overwrite quick add modal specific changes
      // its done by TT
      forCartDrawer(productElement) {
        if (!(productElement instanceof HTMLElement)) return;
      
        // Hide via class
        const HIDE_CLASS = 'hidden';
        const HIDE_SELECTOR = [
          '.product-bundle',
          '.product__media-wrapper',
          '.shopify-app-block',
          '.size-chat-wrap',
          '.shopify-price-block',
          '.tieroffers',
          '#review-open-fix',
          '.product__view-details',
          '.product-form__quantity'
        ];
        productElement.querySelectorAll(HIDE_SELECTOR.join(',')).forEach((el) => {
          el.classList.add(HIDE_CLASS);
        });
      
        // Targets
        const productTitle  = productElement.querySelector('.product__title');
        if (!productTitle) return;
      
        const productVendor = productElement.querySelector('.product__text.inline-richtext');
        const rating        = productElement.querySelector('.shopify-app-block');
        const mediaContent  = productElement.querySelector('.product__media.media');
        const price         = productElement.querySelector('[id^="price-"]');
      
        // Prepare wrapper/content (reuse if exist)
        let wrap    = productElement.querySelector('.product-title-price-wrap');
        let content = wrap?.querySelector('.product-title-price-content');
      
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'product-title-price-wrap';
        }
        if (!content) {
          content = document.createElement('div');
          content.className = 'product-title-price-content';
        }
      
        // ---- IMPORTANT ORDER TO AVOID HierarchyRequestError ----
        // Capture the ORIGINAL parent *before* moving productTitle anywhere
        const originalParent = productTitle.parentNode;
      
        // Insert wrap into DOM before productTitle (only if wrap isn't already connected)
        if (!wrap.isConnected) {
          // Insert the wrapper at the title's current position first
          originalParent.insertBefore(wrap, productTitle);
        }
      
        // Ensure content is inside wrap
        if (content.parentNode !== wrap) {
          wrap.appendChild(content);
        }
      
        // Now move children into their final places
        appendIfExists(wrap,    mediaContent);   // optional: move media next to content
        appendIfExists(content, productTitle);   // title first inside content
        appendIfExists(content, productVendor);
        appendIfExists(content, rating);
        appendIfExists(content, price);
      
        // ---------------- helpers ----------------
        function appendIfExists(parentEl, childEl) {
          if (!parentEl || !childEl) return;
          if (childEl.parentNode === parentEl) return;
          parentEl.appendChild(childEl);
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        // TT customizations
        this.forCartDrawer(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
